import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import FormInput from '../../../../components/Form/FormInput';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { CONSTANT } from '../../../../utils/constants';
import { validateURL } from '../../../../utils/stringHelper';
import PropertyField from '../../../../components/Properties/PropertyField';

import { Button } from 'primereact/button';

function ExternalResourceManager({
  isOpen,
  resource,
  onUpdate,
  onCreate,
  emptyPayload,
  setPanelIsOpen,
  loading
}) {
  const [title, setTitle] = useState('');
  const [publicList, setPublicList] = useState([]);
  const [theme, setTheme] = useState('');
  const [srcUrl, setSrcUrl] = useState('');
  const [instruction, setInstruction] = useState('');

  useEffect(() => {
    if (resource) {
      setTitle(resource.title);
      setPublicList(
        resource?.public_list?.filter((ot) => ot.type === 'sy_public_list').map((ot) => ot.id)
      );
      setTheme(resource.theme);
      setSrcUrl(resource.src_url);
      setInstruction(resource.instruction);
    } else {
      setTitle('');
      setPublicList([]);
      setTheme('');
      setSrcUrl('');
      setInstruction('');
    }
  }, [resource, emptyPayload]);

  const handleValidate = () => {
    const resourcePayload = {
      title,
      public_list: publicList,
      theme,
      src_url: srcUrl,
      instruction
    };
    resource ? onUpdate(resourcePayload) : onCreate(resourcePayload);
  };

  const onClose = () => {
    setPanelIsOpen(false);
  };

  const formIsValid = () => {
    return title?.length > 3 && publicList && theme?.length > 3 && srcUrl?.length > 3;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ressource`}
        loading={loading}
        disabled={!formIsValid()}
        onClick={handleValidate}
        severity="success"
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 900 }}
      visible={isOpen}
      position="right"
      onHide={onClose}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${resource ? 'Modifier' : 'Ajouter'} une Resource thématique`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <FormInput key="title" label={'Titre'} required isValid={title?.length > 3}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre de la resource thématique"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>

          <FormInput key="public_list" label={'Public cible'} required isValid={publicList.length}>
            <PropertyField
              type={'sy_public_list'}
              selectedPropertyList={publicList}
              setSelectedPropertyList={setPublicList}
              scope={'solarys'}
            />
          </FormInput>
          <FormInput key="theme" label={'Thème'} required isValid={theme?.length > 3}>
            <Dropdown
              value={theme}
              options={CONSTANT.solarys.resourceThemes}
              optionLabel="label"
              onChange={(e) => setTheme(e.value)}
              placeholder="Indiquez le thème de la ressource thématique"
              className="grow"
            />
          </FormInput>
          <FormInput
            label={'Url de la source'}
            errorMessage={!validateURL(srcUrl) && "L'URL doit commencer par http:// ou https://"}
            required
            isValid={srcUrl?.length > 3}>
            <InputText
              id="src_url"
              value={srcUrl}
              maxLength={300}
              placeholder="Veuillez saisir l'url de la source"
              onChange={(e) => setSrcUrl(e.target.value)}
              invalid={!validateURL(srcUrl)}
            />
          </FormInput>

          <FormInput key="instruction" label={'Instruction'}>
            <InputText
              id="instruction"
              value={instruction}
              maxLength={300}
              placeholder="Veuillez saisir les instructions"
              onChange={(e) => setInstruction(e.target.value)}
            />
          </FormInput>
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default ExternalResourceManager;
